import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { verificationSchema } from "../../Schema/authSchema";
import { useState, useEffect } from "react";
import { useMutation } from "react-query";
import { recoverPassword, verifyCode } from "../../Services/Auth";
import { Error, Success } from "../../Components/Modal";
import Button from "../../Components/Button";
import "../../styles/PremiumLogin.css";

export default function Verification() {
  const navigate = useNavigate();
  const [email, setEmail] = useState(localStorage.getItem("email"));
  const [timer, setTimer] = useState(120);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(verificationSchema),
  });

  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const { mutate, isLoading } = useMutation((data) => verifyCode(data), {
    retry: false,
    onSuccess: (res) => {
      // console.log("Verification Response: ", res.data);
      Success("Verification", res.data?.message);
      navigate("/set-password", { replace: true });
    },
    onError: (err) => {
      // console.log("verifyCode Err: ", err);
      Error(err.response.data?.message);
    },
  });

  const { mutate: mutateResendCode, isLoading: resendCodeLoading } =
    useMutation((data) => recoverPassword(data), {
      retry: false,
      onSuccess: (res) => {
        // console.log("Recover: ", res.data);
        Success("Resend Code", res.data?.message);
        setTimer(120); // Reset timer
      },
      onError: (err) => {
        // console.log("recoverPassword Err: ", err);
        Error(err.response.data?.message);
      },
    });

  const submit = (data) => {
    // console.log(data, "data");
    localStorage.setItem("code", data?.verificationCode);
    mutate({ email: email, otp: data?.verificationCode });
  };

  console.log(errors);
  return (
    <section className="loginPage">
      <div className="container-fluid p-0">
        <div className="row g-0 align-items-center">
          <div className="col-lg-6 px-4 loginBgLeft d-none d-lg-flex flex-column justify-content-center">
            <div className="loginBgLeftPattern" style={{ backgroundImage: "url('/images/loginLeftContentBG.png')" }} />
            <div className="loginLeftContent">
              <img
                src="images/loginLogo.png"
                alt="MUVRRS Logo"
                className="img-fluid loginLogo"
              />
              <p className="loginLeftTagline">
                Recover your access. <strong>Safe and secure.</strong>
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 loginBgRight">
            <div className="loginCard">
              <div className="text-center d-block d-lg-none mb-4">
                <img
                  src="images/loginLogo.png"
                  alt="MUVRRS Logo"
                  className="loginLogo img-fluid"
                />
              </div>
              <div className="formBox">
                <div className="formHeading mb-4">
                  <h2>Password Recovery</h2>
                  <p>Enter the verification code sent to your email</p>
                </div>
                <form
                  className="py-2"
                  onSubmit={handleSubmit(submit)}
                >
                  <div className="form-field">
                    <label htmlFor="verificationCode" className="siteLabel">
                      Verification Code<span className="text-danger">*</span>
                    </label>
                    <div className="input-icon-wrapper">
                      <i className="fas fa-key input-icon-left" />
                      <input
                        type="number"
                        className="siteInput"
                        placeholder="Enter Verification Code"
                        id="verificationCode"
                        {...register("verificationCode")}
                      />
                    </div>
                    {errors?.verificationCode && (
                      <span className="text-danger">
                        {errors?.verificationCode?.message}
                      </span>
                    )}
                  </div>

                  <div className="w-100 text-end mb-3">
                    {timer > 0 ? (
                      <span className="text-muted small" style={{ fontSize: "0.88rem", fontWeight: "600" }}>
                        Resend Code in {Math.floor(timer / 60).toString().padStart(2, '0')}:{(timer % 60).toString().padStart(2, '0')}
                      </span>
                    ) : (
                      <Button
                        className="forgotLink"
                        onClick={() => mutateResendCode({ email })}
                        style={{ border: 0, backgroundColor: "transparent" }}
                        loading={resendCodeLoading}
                      >
                        Resend Code
                      </Button>
                    )}
                  </div>
                  <div className="form-field mt-4 text-center">
                    <Button
                      type="submit"
                      className="siteBtn w-100 mb-3"
                      loading={isLoading}
                    >
                      Continue
                    </Button>
                    <Link
                      to="/superadmin"
                      className="siteBtn2 w-100 mb-3"
                      onClick={() => {
                        localStorage.removeItem("email");
                        localStorage.removeItem("code");
                      }}
                    >
                      Back To Sign In
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
